import { render, staticRenderFns } from "./warrantyView.pug?vue&type=template&id=316772c4&lang=pug&"
import script from "./warrantyView.js?vue&type=script&lang=js&"
export * from "./warrantyView.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CVM7Z9V\\OneDrive - Allianz\\Escritorio\\apps\\mavalue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('316772c4')) {
      api.createRecord('316772c4', component.options)
    } else {
      api.reload('316772c4', component.options)
    }
    module.hot.accept("./warrantyView.pug?vue&type=template&id=316772c4&lang=pug&", function () {
      api.rerender('316772c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/warrantyLayout/views/warrantyView/index.vue"
export default component.exports